import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AuthProvider } from "@/components/admin/auth";
import AdminLayout from "@/components/admin/AdminLayout";
import Home from "@/pages/public/Home";
import Deals from "@/pages/public/Deals";
import DealPage from "@/pages/public/DealPage";
import StaticPage from "@/pages/public/StaticPage";
import { Coupons, Stores, Categories, Guides, GuidePage, Compare, Contact } from "@/pages/public/Pages";
import FestivePage from "@/pages/public/FestivePage";
import { SignInPage, SignUpPage, AccountPage } from "@/pages/public/AccountPages";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import AdminLogin from "@/pages/admin/AdminLogin";
import { ForgotPassword, ResetPassword } from "@/pages/admin/PasswordReset";
import Dashboard from "@/pages/admin/Dashboard";
import AdminDeals from "@/pages/admin/AdminDeals";
import ImportPage from "@/pages/admin/ImportPage";
import Catalog from "@/pages/admin/Catalog";
import ContentPage from "@/pages/admin/ContentPage";
import Automation from "@/pages/admin/Automation";
import SocialPage from "@/pages/admin/SocialPage";
import LaunchChecklist from "@/pages/admin/LaunchChecklist";
import Customers from "@/pages/admin/Customers";
import CustomerAnalytics from "@/pages/admin/CustomerAnalytics";
import IntegrationsPage from "@/pages/admin/IntegrationsPage";
import Earnings from "@/pages/admin/Earnings";
import SettingsPage from "@/pages/admin/SettingsPage";
import Team from "@/pages/admin/Team";
import BrandingPage from "@/pages/admin/BrandingPage";
import SocialManager from "@/pages/admin/SocialManager";
import { SiteBranding } from "@/components/site/SiteBranding";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const PublicShell = () => (
  <>
    <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:p-2 focus:bg-white">Skip to content</a>
    <Header />
    <main id="main"><Outlet /></main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <SiteBranding />
          <Routes>
            <Route element={<ClerkAuthProvider><PublicShell /></ClerkAuthProvider>}>
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/" element={<Home />} />
              <Route path="/deals" element={<Deals />} />
              <Route path="/deal/:slug" element={<DealPage />} />
              <Route path="/category/:slug" element={<Deals mode="category" />} />
              <Route path="/store/:slug" element={<Deals mode="merchant" />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/stores" element={<Stores />} />
              <Route path="/coupons" element={<Coupons />} />
              <Route path="/offers/diwali" element={<FestivePage />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guide/:slug" element={<GuidePage />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<StaticPage />} />
            </Route>
            <Route element={<AuthProvider><Outlet /></AuthProvider>}>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="deals" element={<AdminDeals />} />
                <Route path="import" element={<ImportPage />} />
                <Route path="catalog" element={<Catalog />} />
                <Route path="content" element={<ContentPage />} />
                <Route path="automation" element={<Automation />} />
                <Route path="social" element={<SocialPage />} />
                <Route path="social-manager" element={<SocialManager />} />
                <Route path="earnings" element={<Earnings />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="branding" element={<BrandingPage />} />
                <Route path="integrations" element={<IntegrationsPage />} />
                <Route path="team" element={<Team />} />
                <Route path="launch" element={<LaunchChecklist />} />
                <Route path="customers" element={<Customers />} />
                <Route path="customer-analytics" element={<CustomerAnalytics />} />
              </Route>
            </Route>
          </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
